import { Component, Output, EventEmitter, inject, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ToasterService } from '../../../../services/toaster/toaster.service';

@Component({
  selector: 'app-add-phone',
  standalone: true,
  imports: [FormsModule],
  templateUrl: './add-phone.html',
})
export class AddPhone {
  private toaster = inject(ToasterService);

  @Output() cancel = new EventEmitter<void>();

  phoneNumber = signal('');

  onSubmit() {
    if (!this.phoneNumber()) {
      this.toaster.warning('Please enter a phone number.');
      return;
    }
    // Mock successful update
    this.toaster.success('Phone number added successfully!');
    this.cancel.emit();
  }

  onCancel() {
    this.cancel.emit();
  }
}
